/* eslint-disable react/destructuring-assignment */
import { LoadingButton } from '@mui/lab';
import { Button, Link } from '@mui/material';
import { styled } from '@mui/material/styles';

const PrimaryButtonStyles = styled(Button)(({ theme }) => ({
  fontSize: '1rem',
  borderRadius: '6px',
  textTransform: 'none',
  fontWeight: 500,
  height: '48px',
  '&.Mui-disabled': {
    borderColor: theme.palette.action.disabledBackground,
    backgroundColor: theme.palette.action.disabledBackground,
  },
  '&:hover': {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.main,
  },
}));

const SecondaryButtonStyles = styled(Button)(({ theme }) => ({
  fontSize: '1rem',
  borderRadius: '6px',
  textTransform: 'none',
  fontWeight: 500,
  height: '48px',
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.paper,
  borderWidth: '1px',
  borderColor: theme.palette.grey.A400,
  borderStyle: 'solid',
  '&:hover': {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    borderColor: theme.palette.grey.A400,
  },
  '&.Mui-disabled': {
    color: theme.palette.text.disabled,
    borderColor: theme.palette.grey.A400,
    backgroundColor: theme.palette.background.paper,
  },
}));

const PrimaryLiteButtonStyles = styled(Button)(({ theme }) => ({
  fontSize: '1rem',
  fontWeight: 500,
  borderRadius: '6px',
  border: '1px',
  textTransform: 'none',
  '&:hover': {
    color: theme.palette.primary.main,
  },
}));

const PrimaryButtonRoundedStyles = styled(Button)({
  fontSize: '1rem',
  borderRadius: '100px',
  textTransform: 'none',
  fontWeight: 500,
});

const PriamryButtonOutlinedStyles = styled(Button)(({ theme }) => ({
  fontSize: '1rem',
  borderRadius: '6px',
  textTransform: 'none',
  fontWeight: 500,
  backgroundColor: 'inherit',
  height: '48px',
  color: theme.palette.primary.main,
  borderWidth: '1px',
  borderColor: theme.palette.primary.main,
  borderStyle: 'solid',
  '&:hover': {
    backgroundColor: theme.palette.background.paper,
  },
  '&.Mui-disabled': {
    borderColor: theme.palette.action.disabledBackground,
    color: theme.palette.text.disabled,
    backgroundColor: theme.palette.background.paper,
  },
}));

const PrimaryLoadingButtonStyles = styled(LoadingButton)(({ theme }) => ({
  fontSize: '1rem',
  borderRadius: '6px',
  textTransform: 'none',
  fontWeight: 500,
  height: '48px',
  '&.Mui-disabled': {
    borderColor: theme.palette.action.disabledBackground,
    backgroundColor: theme.palette.action.disabledBackground,
  },
  '&.Mui-disabled .MuiLoadingButton-loadingIndicator': {
    color: theme.palette.primary.main,
  },
  '&:hover': {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.main,
  },
}));

const SecondaryLoadingButtonStyles = styled(LoadingButton)(({ theme }) => ({
  fontSize: '1rem',
  borderRadius: '6px',
  textTransform: 'none',
  fontWeight: 500,
  height: '48px',
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.background.paper,
  borderWidth: '1px',
  borderColor: theme.palette.grey.A400,
  borderStyle: 'solid',
  '& .MuiSvgIcon-root': {
    fontSize: '20px',
  },
  '&:hover': {
    backgroundColor: theme.palette.background.paper,
  },
  '&.Mui-disabled': {
    color: theme.palette.text.disabled,
    borderColor: theme.palette.grey.A400,
    backgroundColor: theme.palette.background.paper,
  },
  '&.Mui-disabled .MuiLoadingButton-loadingIndicator': {
    color: theme.palette.primary.main,
  },
}));

const IconLoadingButtonStyles = styled(LoadingButton)(({ theme }) => ({
  fontSize: '0.875rem',
  textTransform: 'none',
  fontWeight: 700,
  height: 'auto',
  minWidth: '64px',
  padding: '4px 5px',
  backgroundColor: 'transparent',
  border: 0,
  display: 'flex',
  color: theme.palette.primary.main,
  '& .MuiSvgIcon-root': {
    fontSize: '20px',
  },
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '&.Mui-disabled': {
    color: theme.palette.text.disabled,
    borderColor: theme.palette.grey.A400,
    backgroundColor: 'transparent',
  },
  '&.Mui-disabled .MuiLoadingButton-loadingIndicator': {
    color: theme.palette.primary.main,
  },
}));

const LinkButtonStyles = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  '&:hover': {
    color: theme.palette.primary.main,
  },
  '&.Mui-disabled': {
    color: theme.palette.text.disabled,
  },
}));

// @TODO: Here you have to create two components.
// And file names should like this way :- primary-button.
// And please use Must use destructuring props assignment
// According to your changes please change index.ts file as well.

export const PrimaryButton = (props: any) => (
  <PrimaryButtonStyles {...props} variant="contained" disableElevation>
    {props.children}
  </PrimaryButtonStyles>
);

export const SecondaryButton = (props: any) => (
  <SecondaryButtonStyles {...props} variant="contained" disableElevation>
    {props.children}
  </SecondaryButtonStyles>
);

export const PrimaryLiteButton = (props: any) => (
  <PrimaryLiteButtonStyles {...props} variant="contained" disableElevation>
    {props.children}
  </PrimaryLiteButtonStyles>
);

export const PrimaryRoundedButton = (props: any) => (
  <PrimaryButtonRoundedStyles {...props} variant="contained" disableElevation>
    {props.children}
  </PrimaryButtonRoundedStyles>
);

export const PrimaryOutlinedButton = (props: any) => (
  <PriamryButtonOutlinedStyles {...props} variant="contained" disableElevation>
    {props.children}
  </PriamryButtonOutlinedStyles>
);

export const PrimaryLoadingButton = (props: any) => (
  <PrimaryLoadingButtonStyles {...props} variant="contained" disableElevation>
    {props.children}
  </PrimaryLoadingButtonStyles>
);

export const SecondaryLoadingButton = (props: any) => (
  <SecondaryLoadingButtonStyles {...props} variant="contained" disableElevation>
    {props.children}
  </SecondaryLoadingButtonStyles>
);

export const IconLoadingButton = (props: any) => (
  <IconLoadingButtonStyles {...props} variant="contained" disableElevation>
    {props.children}
  </IconLoadingButtonStyles>
);

export const PrimaryLinkButton = (props: any) => (
  <LinkButtonStyles component="button" variant="body2" underline="none" {...props}>
    {props.children}
  </LinkButtonStyles>
);
